import * as api from '../../api';
import { pagingDataUtilities } from '../../common';

export const fetchListActions = api.fetchActions('published', 'fetch-published-messages');
export const closeMessageActions = api.fetchActions('published', 'close-message');
export const pagingActions = pagingDataUtilities.pagingActions('published', 'paging');

export const actionTypes = {
  ...fetchListActions.actionTypes,
  ...closeMessageActions.actionTypes,
  ...pagingActions.actionTypes,
  CLOSE_MESSAGE_SHOW_MODAL: "published.close-message-show-modal",
  CLOSE_MESSAGE_CLOSE_MODAL: "published.close-message-close-modal",
}

export function fetchList() {
  return (dispatch, getState) => {
    const state = getState();
    const { published } = state;
    const { pagingData } = published;
    const { currentPage, itemsPerPage } = pagingData || {};
    const params = {
      page: currentPage,
      perPage: itemsPerPage
    };
    return dispatch(api.shouldExecute(['published', 'listState'], api.getThunk(`/dashboard-messages/GetOpenDashboardMessages`, params, fetchListActions)));
  }
}
export const closeMessage = (id) => api.putThunk(`/dashboard-messages/${id}/close-message`, {}, closeMessageActions, { id });

export const changePageNumber = (page) => pagingDataUtilities.changePage(page, pagingActions);

export function closeMessageShowModal(id) {
  return {
    type: actionTypes.CLOSE_MESSAGE_SHOW_MODAL,
    messageId: id
  }
}

export function closeMessageCloseModal() {
  return {
    type: actionTypes.CLOSE_MESSAGE_CLOSE_MODAL
  }
}
